import styled from 'styled-components';

export const StyledAdminDeviceGroupsSumRow = styled.div`
  display: flex;
  padding: 0.1rem 0 0.1rem 2.7rem;
  border-radius: 0.6rem;

  &:not(:last-child) {
    margin-bottom: 0.2rem;
  }

  .admin-list-cell-container {
    flex-grow: 1;
    flex-basis: 10%;
    overflow: hidden;
    margin: 0 0.1rem;

    &.adjust {
      width: 19rem;
      flex-grow: initial;
    }

    &.sum-cell {
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.bg8 : props.theme.mainBackground};
      border: 1px solid ${(props) => props.theme.accent2};
      border-radius: 0.4rem;

      &:last-child {
        border-right: none;
      }

      & > * {
        height: 100%;
        width: 100%;
      }
    }
  }

  .admin-list-cell-text {
    padding: 0.3rem 0.6rem;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 150%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
